import { apiBaseFrom } from '../../shared/apiBase'
export interface ApiConfig {
  baseURL: string
  graphqlURL: string
  authURL: string
  orderURL: string
  employeeRostersURL: string
  employeesURL: string
  importDefinitionsURL: string
  importTargetsURL: string
  importRunsURL: string
  reportOrderCompletionURL: string
  orderLineReservationURL: string
  originCodeURL: string
  truckingCompanyURL: string
  damageCodeURL: string
  attachmentTypeURL: string
  tirReceiptURL: string
  containerMovementURL: string
  containerMovementReasonCodeURL: string
  yardPickCancelReasonCodeURL: string
  chassisURL: string
  gensetURL: string
  gangURL: string
  partnerURL: string
  warehouseURL: string
  shipURL: string
  yardURL: string
  bayURL: string
  cellURL: string
  locationProximityURL: string
  yardPickURL: string
  yardPicksPagedURL: string
  containerURL: string
  inventorySupplyURL: string
  inventorySupplyProjectionURL: string
  orderFulfillmentWorkspaceURL: string
  orderManagementURL: string
  fulfillmentOversightURL: string
  forecastURL: string
  jobScheduleURL: string
  userURL: string
  healthURL: string
  monitoredServicesURL: string
  serviceEventsURL: string
  publicStatusURL: string
  palletURL: string
  palletIncidentURL: string
  palletIncidentReasonCodeURL: string
  palletIncidentStatusURL: string
  palletIncidentPredefinedPhotoURL: string
  warehouseRoomURL: string
  sensorURL: string
  roomClimateURL: string
  headers: {
    'Content-Type': string
  }
}

export function useApiConfig() {
  const config = useRuntimeConfig()
  const apiBase = apiBaseFrom(config.public.apiBase)

  return {
    baseURL: apiBase,
    graphqlURL: `${apiBase}/graphql`,
    authURL: `${apiBase}/auth`,
    orderURL: `${apiBase}/orders`,
    employeeRostersURL: `${apiBase}/employee-rosters`,
    employeesURL: `${apiBase}/employees`,
    importDefinitionsURL: `${apiBase}/import-definitions`,
    importTargetsURL: `${apiBase}/import-targets`,
    importRunsURL: `${apiBase}/import-runs`,
    reportOrderCompletionURL: `${apiBase}/reports/order-completion`,
    orderLineReservationURL: `${apiBase}/order-line-reservations`,
    originCodeURL: `${apiBase}/OriginCode`,
    truckingCompanyURL: `${apiBase}/trucking-companies`,
    damageCodeURL: `${apiBase}/trailer-interchange-damage-codes`,
    attachmentTypeURL: `${apiBase}/trailer-interchange-attachment-types`,
    tirReceiptURL: `${apiBase}/trailer-interchange-receipts`,
    containerMovementURL: `${apiBase}/container-movements`,
    containerMovementReasonCodeURL: `${apiBase}/container-movement-reason-codes`,
    yardPickCancelReasonCodeURL: `${apiBase}/yard-pick-cancel-reason-codes`,
    chassisURL: `${apiBase}/chassis`,
    gensetURL: `${apiBase}/gensets`,
    gangURL: `${apiBase}/gang`,
    partnerURL: `${apiBase}/Partner`,
    warehouseURL: `${apiBase}/Warehouse`,
    shipURL: `${apiBase}/Ship`,
    yardURL: `${apiBase}/Yard`,
    bayURL: `${apiBase}/Bay`,
    cellURL: `${apiBase}/Cell`,
    locationProximityURL: `${apiBase}/LocationProximity`,
    yardPickURL: `${apiBase}/YardPick`,
    // The paged yard pick collection. Kebab-plural per the API route conventions; the legacy
    // YardPick route above still serves the unpaged list and everything else.
    yardPicksPagedURL: `${apiBase}/yard-picks`,
    containerURL: `${apiBase}/Container`,
    inventorySupplyURL: `${apiBase}/InventorySupply`,
    inventorySupplyProjectionURL: `${apiBase}/InventorySupply`,
    orderFulfillmentWorkspaceURL: `${apiBase}/OrderFulfillmentWorkspace`,
    orderManagementURL: `${apiBase}/OrderManagement`,
    fulfillmentOversightURL: `${apiBase}/FulfillmentOversight`,
    forecastURL: `${apiBase}/Forecast`,
    jobScheduleURL: `${apiBase}/JobSchedule`,
    userURL: `${apiBase}/users`,
    healthURL: `${apiBase}/health`,
    monitoredServicesURL: `${apiBase}/monitored-services`,
    serviceEventsURL: `${apiBase}/service-events`,
    publicStatusURL: `${apiBase}/health/status`,
    palletURL: `${apiBase}/Pallet`,
    palletIncidentURL: `${apiBase}/PalletIncident`,
    palletIncidentReasonCodeURL: `${apiBase}/PalletIncidentReasonCode`,
    palletIncidentStatusURL: `${apiBase}/PalletIncidentStatus`,
    palletIncidentPredefinedPhotoURL: `${apiBase}/PalletIncidentPredefinedPhoto`,
    warehouseRoomURL: `${apiBase}/WarehouseRoom`,
    sensorURL: `${apiBase}/Sensor`,
    roomClimateURL: `${apiBase}/room-climate`,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }
}
